<nb-tabset fullWidth (changeTab)="changeTab($event)" class="fixed-tabset">
  <nb-tab tabId="1" [tabTitle]="'core.utils.asset-filter-tab.reference-data.name' | translate"
          class="pt-5 overflow-visible">

  </nb-tab>

  <!-- @if (!isFidjiAct) {
    <nb-tab tabId="2" [tabTitle]="'History' | translate" class="pt-5" disabled>
      @if (selectedTabId === 2) {
        <app-site-history [perimeter]="perimeter"></app-site-history>
      }
    </nb-tab>
  } -->

  @if (profitsEnabled) {
    <nb-tab tabId="2" [tabTitle]="'Share of profits' | translate" class="pt-5" disabled>
    </nb-tab>
  }

  @if (quotesEnabled) {
    <nb-tab tabId="3" [tabTitle]="'Payers distribution keys' | translate" class="pt-5">
    </nb-tab>
  }

  @if (energyEnabled) {
    <nb-tab tabId="4" [tabTitle]="'Consumption (truncated)' | translate" class="pt-5">
    </nb-tab>
  }

  @if (energyEnabled$ | async) {
    <nb-tab tabId="5" [tabTitle]="'ENERGY/CARBON OBJECTIVES' | translate" class="pt-5">
    </nb-tab>
  }

  @if (energyEnabled) {
    <nb-tab tabId="6" [tabTitle]="'Refrigerant fluids' | translate" class="pt-5">
    </nb-tab>
  }

  @if (!isFidjiAct && photosEnabled) {
    <nb-tab tabId="7" [tabTitle]="'Pictures' | translate" class="pt-5" disabled>
    </nb-tab>
  }

  @if (!isFidjiAct) {
    <nb-tab tabId="8" [tabTitle]="'Documents' | translate" class="pt-5">
    </nb-tab>
  }

  <nb-tab tabId="9" [tabTitle]="'Site notes' | translate" class="pt-5">
  </nb-tab>
</nb-tabset>

<div class="tab-content">
  @if (selectedTabId === 1) {
    @if (refreshKey >= 0) {
      <app-site-reference-datas
        [perimeter]="perimeter"
        [focusedPerimeterId]="focusedPerimeterId"
        [refreshKey]="refreshKey"
      ></app-site-reference-datas>
    }
  }
  @if (selectedTabId === 3) {
    <app-site-quote-part [perimeter]="perimeter"></app-site-quote-part>
  }
  @if (selectedTabId === 4) {
    <app-site-kwh-consumption [multiPerimeter]="perimeter" [readOnly]="readOnly"></app-site-kwh-consumption>
  }
  @if (selectedTabId === 5) {
    <app-site-objective-energy-carbon [perimeter]="perimeter" [readOnly]="readOnly"></app-site-objective-energy-carbon>
  }
  @if (selectedTabId === 6) {
    <app-site-refrigerant-fluids [perimeter]="perimeter" [readOnly]="readOnly"></app-site-refrigerant-fluids>
  }
  @if (perimeterIds &&  selectedTabId === 8) {
    <app-ag-grid-documents [displayAsDialog]="false" [perimeterIds]="perimeterIds" [perimeterLabel]="perimeter?.name"></app-ag-grid-documents>
  }
  @if (perimeterIds &&  selectedTabId === 9) {
    <app-site-notes [site]="perimeter"></app-site-notes>
  }
</div>
